export default function PadlockIcon({ width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={width}
      viewBox="0 0 71 70"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8598 31.5211C26.8505 28.4954 43.271 28.4954 59.2643 31.5211C61.4081 31.9287 62.956 33.8075 62.9409 35.9893V63.4554C62.9409 65.4127 61.5507 67.094 59.628 67.4604L57.1499 67.9288C49.8628 69.3079 42.4676 70 35.0529 70C27.6441 70 20.2529 69.3079 12.9749 67.9288L10.4791 67.4604C8.55378 67.0966 7.16033 65.4127 7.15771 63.4554V35.5817C7.16033 33.6211 8.55378 31.9398 10.4791 31.5734L10.8598 31.5211ZM30.4893 57.154C33.424 58.3001 36.6826 58.3001 39.6174 57.154C40.1414 56.9564 40.4031 56.3748 40.2075 55.8508L37.832 49.1491C39.321 47.9683 39.9026 45.9723 39.2772 44.1779C38.6518 42.3827 36.9593 41.1783 35.0563 41.1783C33.1565 41.1783 31.4608 42.3827 30.8386 44.1779C30.2132 45.9723 30.7922 47.9677 32.2838 49.1491L29.9077 55.8508C29.7095 56.3715 29.9685 56.9531 30.4893 57.154Z"
        fill="#1A1A1A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2341 23.6304V21.2615C19.2341 12.4239 26.4238 5.23354 35.2621 5.23354C44.1003 5.23354 51.29 12.4239 51.29 21.2615V23.6807C53.04 23.8894 54.7848 24.1361 56.5237 24.4121V21.2615C56.5237 9.5382 46.986 -7.62939e-05 35.2621 -7.62939e-05C23.5381 -7.62939e-05 14.0005 9.5382 14.0005 21.2615V24.3507C15.7394 24.0798 17.4835 23.8345 19.2341 23.6304Z"
        fill="#1A1A1A"
      />
    </svg>
  );
}
